import interact from 'interactjs';
import { DesignerElementTypes } from '../designer.enum';

export interface IBaseDesignerElement {
  id?: string;
  type: DesignerElementTypes;
  componentName?: string;
  selected?: boolean;
  position?: IDesignerElementPosition;
  sizes?: IDesignerElementSize;
  z?: number;
  $el?: HTMLElement;
  meta?: any;
  scale?: number;
}

export interface IDesignerElementPosition {
  x: number;
  y: number;
}

export interface IDesignerElementSize {
  width: number;
  height: number;
}

export class DesignerElement {
  $el?: HTMLElement;

  id: string;
  type: DesignerElementTypes;
  componentName?: string;
  selected?: boolean;
  position?: IDesignerElementPosition;
  sizes?: IDesignerElementSize;
  z?: number;
  meta: any;
  scale: number;

  constructor(data: IBaseDesignerElement) {
    const { id, type, position, sizes, z, $el, selected, meta, scale } = data;

    this.id = id || `${type}-${new Date().getTime().toString()}`;
    this.type = type;
    this.componentName = `ed-designer-${type}`;
    this.position = position || { x: 0, y: 0 };
    this.sizes = sizes;
    this.z = z || 2;
    this.selected = selected;
    this.meta = meta;
    this.scale = scale;

    if ($el) {
      this.setHTMLElement($el);
    }
  }

  setHTMLElement(el: HTMLElement) {
    const { x, y } = this.position;
    const scale = this.scale ? this.scale : 1;
    const traslateFactorX = this.sizes ? (this.sizes.width - (this.sizes.width * scale)) / 2 : 1;
    const traslateFactorY = this.sizes ? (this.sizes.height - (this.sizes.height * scale)) / 2: 1;

    this.$el = el;
    this.$el.style.transform = this.type == 'text' ? `translate(${x - traslateFactorX}px, ${y - traslateFactorY}px) scale(${scale})` : `translate(${x}px, ${y}px)`;
    this.$el.setAttribute('data-x', x.toString());
    this.$el.setAttribute('data-y', y.toString());
    this.$el.setAttribute('scale', scale.toString());
  }

  getElementToSaveFormatted() {
    const { id, type, position, sizes, meta, z } = this;

    return {
      id,
      type,
      position: {
        x: position.x,
        y: position.y,
        z,
      },
      sizes,
      meta
    };
  }

  setDraggable() {
    interact(this.$el)?.draggable({ onmove: this.onMove.bind(this) });
  }

  turnOnDraggable() {
    if (this.$el) {
      interact(this.$el)?.draggable({ enabled: true, });
    }
  }

  turnOffDraggable() {
    if (this.$el) { 
      interact(this.$el)?.draggable({ enabled: false, });
    }
  }

  onMove(event: any) {
    const target = event.target;

    const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
    const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

    target.style.transform = `translate(${x}px, ${y}px)`;

    target.setAttribute('data-x', x.toString());
    target.setAttribute('data-y', y.toString());

    this.position = { x, y };
  }

  setBackgroundColor(color: string) {
    if (this.meta) {
      this.meta.backgroundColor = color;
    } else {
      this.meta = { backgroundColor: color };
    }
  }

  setZPosition(z: number) {
    this.z = z;
  }
}